import { useDataQuery } from "hooks/useData";
import React from "react";
import MultiSelect from "ui/MultiSelect";

type Sphere = { id: number; title: string };

const SphereSelect: React.FC<{
  selectedIds: number[];
  onChange: (ids: number[]) => void;
}> = ({ selectedIds, onChange }) => {
  const spheres = useDataQuery("spheres");

  if (!spheres) return <div>Loading…</div>;
  const items = (spheres as Sphere[]).map((s) => ({
    id: s.id,
    label: s.title,
  }));

  return (
    <MultiSelect
      items={items}
      selectedIds={selectedIds}
      onChange={onChange}
    />
  );
};

export default SphereSelect;
